"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _long = _interopRequireDefault(require("./style/long"));

var _short = _interopRequireDefault(require("./style/short"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _label = _interopRequireDefault(require("./style/label"));

var _root = _interopRequireDefault(require("./style/root"));

var _wrapper = _interopRequireDefault(require("./style/wrapper"));

var Progress = function Progress(_ref) {
  var label = _ref.label,
      children = _ref.children,
      inline = _ref.inline,
      className = _ref.className,
      delay = _ref.delay,
      theme = _ref.theme,
      style = _ref.style,
      global = _ref.global;
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var labelContent = '';
  (0, _react.useEffect)(function () {
    if (!isNaN(delay) && delay > 0) {
      setVisible(false);
      var show = setTimeout(function () {
        return setVisible(true);
      }, delay);
      return function () {
        return clearTimeout(show);
      };
    }
  }, [delay]);

  if (label) {
    labelContent = _react["default"].createElement(_label["default"], {
      theme: memoTheme
    }, label);
  } else if (children) {
    labelContent = _react["default"].createElement(_label["default"], {
      theme: memoTheme
    }, children);
  }

  return visible ? _react["default"].createElement(_root["default"], {
    global: global,
    inline: inline,
    theme: memoTheme,
    className: className,
    "data-qa-node": "progress"
  }, labelContent, _react["default"].createElement(_wrapper["default"], {
    theme: memoTheme
  }, _react["default"].createElement(_long["default"], {
    theme: memoTheme
  }), _react["default"].createElement(_short["default"], {
    theme: memoTheme
  }))) : null;
};

Progress.propTypes = {
  label: _propTypes["default"].string,
  global: _propTypes["default"].bool,
  children: _propTypes["default"].any,
  className: _propTypes["default"].string,
  delay: _propTypes["default"].number,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default flex
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.elDivider
     */
    progressBackground: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    progressColor: _propTypes["default"].string,

    /**
     * @default palette.tInactive
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default 1.5
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default 100%
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
};
Progress.defaultProps = {
  global: false,
  delay: 0
};
var _default = Progress;
exports["default"] = _default;